export default "__VITE_ASSET__st4FMMm7__"